/* eslint-disable jsx-a11y/anchor-is-valid */
import { default as cx } from 'classnames'
import * as _ from 'lodash'
import { useHistory, useLocation } from 'react-router'
import React, { useContext, useEffect, useState } from 'react'
import {
  Accordion,
  AccordionContext,
  Card,
  Col,
  Dropdown,
  Row,
  Tab,
  Tabs,
  useAccordionToggle,
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import {
  KNOWLEDGE_ARCHIVED,
  KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH,
} from '@/config'
import UploadedDocuments from '@/routes/UploadedDocuments/UploadedDocuments'
import { convertDataToMarkdownFormat } from '@/utils/appUtils'
import RichMarkdownContent from '@/components/UI/RichMarkdownContent'
import {
  deleteKnowledgeById,
  restoreKnowledgeById,
  getAllKnowledge,
} from '@/store/knowledge/actions'
import {
  isAllKnowledgeLoading,
  isAllKnowledgeSuccess,
  isTopicsLoading,
} from '@/store/knowledge/selector'
import { getAllUserGroupOptions } from '@/store/notifications/actions'
import { getAllIntents as getAllIntentsSelector } from '@/store/questions/selector'
import KGroupsTree from '@/components/UI/KGroupsTree'
import PermissionWrapper from '../PermissionWrapper/PermissionWrapper'
import { TwoButtonModal as KnowledgeConfirmationModal } from '../Common'
import Pagination from '../Pagination/Pagination'
import '@/routes/Knowledge/AllKnowledge/AllKnowledge.scss'
import emptyKnowledge from '@/assets/New-images/empty-knowledge.svg'
import sortIcon from '@/assets/New-images/sort-blue-icon.svg'
import dayjs from 'dayjs'

function ArchiveKnowledgeDatatableView(props: any) {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [perPage, setPerPage] = useState(30)
  const [currentPage, setCurrentPage] = useState(1)
  const allKnowledgeSuccess = useSelector(isAllKnowledgeSuccess)
  const allKnowledgeLoading = useSelector(isAllKnowledgeLoading)
  const topicsLoading = useSelector(isTopicsLoading)
  const allIntents = useSelector(getAllIntentsSelector)

  const [activeTab, setActiveTab] = useState<string>(() => {
    const params = new URLSearchParams(location.search)
    return params.get('activeTab') || 'viewDocument'
  })
  const [activeKey, setActiveKey] = useState(null)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [showDeletePermanentlyModal, setShowDeletePermanentlyModal] =
    useState(false)
  const [deletedRowId, setDeletedRowId] = useState([])

  useEffect(() => {
    if (!topicsLoading) {
      dispatch(getAllUserGroupOptions())
    }
  }, [])

  useEffect(() => {
    // Keep the active tab in sync with the URL's `activeTab` query param.
    const query = new URLSearchParams(location.search)
    const tabFromQuery = query.get('activeTab')
    if (tabFromQuery && tabFromQuery !== activeTab) {
      setActiveTab(tabFromQuery)
    }
    // If there's no param, don't override current state; initial state already defaulted.
  }, [location.search])

  const [query, setQuery] = useState('')

  const onInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setQuery(e.target.value)
  }

  const [selectedNodes, setSelectedNodes] = useState([])

  const deleteConfirmed = async (selectedRowIds: string[]) => {
    await dispatch(deleteKnowledgeById(selectedRowIds, false))
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
    setSelectedNodes([])
  }

  const restoreArchived = async (selectedRowIds: string[]) => {
    await dispatch(restoreKnowledgeById(selectedRowIds))
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
    setSelectedNodes([])
  }

  const onSortHandler = (selector: any, direction: string) => {
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {
          sort_field: selector === 'name' ? 'question' : selector,
          sort_order: direction === 'desc' ? 'dsc' : 'asc',
        },
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
  }

  useEffect(() => {
    if (activeTab === 'viewKnowledge') {
      dispatch(
        getAllKnowledge(
          3,
          currentPage,
          perPage,
          query,
          '',
          {},
          selectedNodes.length > 0,
          props.documentId,
          !props.documentId ? selectedGroup?._id : null,
          true,
          true,
        ),
      )
    }
  }, [selectedGroup, activeTab])

  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] = [...selectedNodes]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedNodes]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedNodes([..._.uniq(data)])
  }

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (
        allKnowledgeSuccess &&
        allKnowledgeSuccess.intents &&
        allKnowledgeSuccess.intents.length > 0
      ) {
        let data: any[] = [
          ...allKnowledgeSuccess.intents.map((intent: any) => intent._id),
        ]
        setSelectedNodes([..._.uniq(data)])
      }
    } else {
      setSelectedNodes([])
    }
  }

  /**
   * Used to paginate data based on per page and page number
   * @param newPerPage
   * @param page
   */
  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage)
    setCurrentPage(page)
    dispatch(
      getAllKnowledge(
        3,
        page,
        newPerPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
  }

  /**
   *
   * @param page Pagination on change of page
   */
  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    dispatch(
      getAllKnowledge(
        3,
        page,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroup?._id,
        true,
        true,
      ),
    )
  }

  const ContextAwareToggle = ({ children, eventKey, breadcrumbs }: any) => {
    const currentEventKey = useContext(AccordionContext)
    setActiveKey(currentEventKey)
    const decoratedOnClick = useAccordionToggle(eventKey, () => {})
    return (
      <>
        <input
          type="checkbox"
          className="mr-2"
          onChange={e => {
            addToSelectedRows(e, eventKey)
          }}
          checked={selectedNodes.indexOf(eventKey) >= 0}
        />

        <span onClick={decoratedOnClick}>
          {children}
          <small className="d-block k-breadcrumb">
            {breadcrumbs.map((b: any) => b.name).join('/')}
          </small>
        </span>
      </>
    )
  }

  const knowledgeHtml = (
    <>
      <div className="all-knowledge-search d-flex flex-wrap align-items-center mb-2">
        <Dropdown className="mr-2 sort-dropdown">
          <Dropdown.Toggle
            className="btn btn-outline-primary font-600 py-1 my-1 "
            variant="default"
            id="dropdown-basic"
          >
            <img src={sortIcon} alt="" className="mr-2" />
            {t('Sort')}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('updated_at', 'desc')
              }}
            >
              {t('Most Recent')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'asc')
              }}
            >
              {t('Ascending')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'desc')
              }}
            >
              {t('Descending')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <div className="web-links my-0 mr-0">
          <input
            type="text"
            className="form-control h-auto"
            placeholder={t('Search Knowledge Base')}
            onChange={onInputChangeHandler}
          />
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mt-1">
        <div className="d-flex align-items-center">
          <div className="custom-checkbox mr-3 align-items-center">
            <input
              type="checkbox"
              className="mr-2"
              id="select-all"
              checked={
                allKnowledgeSuccess &&
                allKnowledgeSuccess.intents &&
                allKnowledgeSuccess.intents.length > 0 &&
                selectedNodes.length === allKnowledgeSuccess.intents.length
              }
              onChange={onSelectAllRows}
            />
            <label htmlFor="select-all" className="mb-0">
              {t('Select all')}
            </label>
          </div>
          {selectedNodes && selectedNodes.length > 0 && (
            <PermissionWrapper>
              <button
                className="btn btn-suggest py-0 font-sm"
                onClick={e => restoreArchived(selectedNodes)}
              >
                {t('Restore Selected')}
              </button>

              <button
                className="btn btn-outline-danger border-0 py-0 font-600 font-sm"
                onClick={e => {
                  setShowDeletePermanentlyModal(true)
                  setDeletedRowId(selectedNodes)
                }}
              >
                {t('Delete Selected')}
              </button>
            </PermissionWrapper>
          )}
        </div>
      </div>
      <Accordion
        defaultActiveKey={
          allKnowledgeSuccess && allKnowledgeSuccess.intents.length > 0
            ? allKnowledgeSuccess.intents[0]._id
            : null
        }
        className="accordion-viewby mt-3"
      >
        {allKnowledgeSuccess &&
          allKnowledgeSuccess.intents &&
          allKnowledgeSuccess.intents.map((knowledge: any, index: number) => {
            const parent = allIntents.find(
              (intent: any) => intent._id === knowledge.parent_id,
            )
            return (
              <Card
                className={cx({
                  active: activeKey === '0',
                  notactive: activeKey !== '0',
                })}
                key={knowledge?._id}
              >
                <Card.Header>
                  <ContextAwareToggle
                    eventKey={knowledge?._id}
                    breadcrumbs={
                      knowledge.breadcrumbs && knowledge.breadcrumbs.length > 0
                        ? knowledge.breadcrumbs
                        : []
                    }
                  >
                    {knowledge.questions && knowledge.questions.length > 0
                      ? knowledge.questions[knowledge.questions.length - 1].text
                      : ''}
                  </ContextAwareToggle>
                </Card.Header>
                <Accordion.Collapse eventKey={knowledge?._id}>
                  <Card.Body>
                    <div>
                      <h3 className="h6 clr-black mb-1">{t('Answer:')}</h3>
                      {knowledge.responses && knowledge.responses.length > 0 ? (
                        <RichMarkdownContent
                          contextText={knowledge.responses[0].text}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                    <Row className="mt-3">
                      <Col md={3} className="my-2 my-md-0">
                        <h3 className="h6 clr-black mb-1">
                          {t('Generated from:')}
                        </h3>
                        <div>{knowledge?.document_name}</div>
                      </Col>
                      <Col md={3} className="my-2 my-md-0">
                        <h3 className="h6 clr-black mb-1">{t('Created by')}</h3>
                        <div>{knowledge?.author_email}</div>
                      </Col>
                      <Col md={3} className="my-2 my-md-0">
                        <h3 className="h6 clr-black mb-1">{t('Level')}</h3>
                        <div>{knowledge?.author_email}</div>
                      </Col>
                      <Col md={3} className="my-2 my-md-0">
                        <h3 className="h6 clr-black mb-1">
                          {t('Last Updated')}
                        </h3>
                        <div>
                          {dayjs
                            .utc(knowledge.updated_at)
                            .local()
                            .format('DD/MM/YYYY hh:mm A')}
                        </div>
                      </Col>
                    </Row>
                    <div className="mt-3 d-none">
                      <h3 className="h6 clr-black mb-1">
                        {t('Possible questions')}
                      </h3>
                      <ol>
                        {knowledge.questions.length > 0
                          ? knowledge.questions.map(
                              (q: { text: string }, i: number) => {
                                return (
                                  <li key={'q_' + knowledge._id + '_' + i}>
                                    <p>{q.text}</p>
                                  </li>
                                )
                              },
                            )
                          : '-'}
                      </ol>
                    </div>
                    <div className="mt-3 d-none">
                      <h3 className="h6 clr-black mb-1">
                        {t('Possible responses')}
                      </h3>
                      <ol>
                        {knowledge.responses.length > 0
                          ? knowledge.responses.map(
                              (
                                response: {
                                  text: string
                                  group_ids: any
                                },
                                i: number,
                              ) => {
                                return (
                                  <li
                                    key={'response_' + knowledge._id + '_' + i}
                                  >
                                    <RichMarkdownContent
                                      contextText={response.text}
                                    />
                                  </li>
                                )
                              },
                            )
                          : '-'}
                      </ol>
                    </div>
                    <div className="mt-3 d-none">
                      <h3 className="h6 clr-black mb-1">
                        {t('Parent question')}
                      </h3>

                      {parent ? parent.name : '-'}
                    </div>
                    <div className="mt-3 text-right">
                      <button
                        className="btn btn-outline-primary font-weight-normal mx-2 py-1 py-md-2"
                        onClick={() => restoreArchived([knowledge._id])}
                      >
                        {t('Restore')}
                      </button>
                      <button
                        className="btn btn-outline-danger font-weight-normal mx-2 py-1 py-md-2"
                        onClick={() => {
                          setShowDeletePermanentlyModal(true)
                          setDeletedRowId([knowledge._id])
                        }}
                      >
                        {t('Delete')}
                      </button>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )
          })}
      </Accordion>

      {/* empty state */}
      {allKnowledgeSuccess &&
        allKnowledgeSuccess.intents.length === 0 &&
        !props.manageDocument && (
          <div className="empty-knowledge text-center my-5">
            <h3 className="h6 clr-grey-txt7 mb-3">
              {t('You have yet to create knowledge')}
            </h3>
            <figure className="h-auto">
              <img src={emptyKnowledge} alt="" />
            </figure>
            <div className="clr-primary font-weight-bold">
              {/* Drop a document here <span className="clr-grey-txt7">or</span>{" "} <br /> */}
              <Link to={KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH}>
                {t('Click here to get started')}
              </Link>
            </div>
          </div>
        )}
      {allKnowledgeSuccess &&
        allKnowledgeSuccess.pagination &&
        allKnowledgeSuccess.intents.length > 0 && (
          <Pagination
            currentPage={currentPage}
            pagination={allKnowledgeSuccess.pagination}
            paginationPerPage={perPage}
            pageChange={handlePerRowsChange}
            onChangePage={handlePageChange}
            style={{ position: 'relative' }}
          />
        )}
    </>
  )

  return (
    <>
      <KnowledgeConfirmationModal
        show={showDeletePermanentlyModal}
        title={t('Confirm Delete')}
        message={t(
          'Are you sure you would like to delete? Deleted items would be deleted permanently',
        )}
        size={'lg'}
        leftButtonText={t('Delete')}
        leftButtonClassName="btn btn-outline-danger font-weight-normal mx-2"
        rightButtonText={t('Cancel')}
        rightButtonClassName="btn btn-outline-primary font-weight-normal mx-2"
        onClickLeftButton={() => {
          setShowDeletePermanentlyModal(false)
          deleteConfirmed(deletedRowId)
        }}
        onClickRightButton={() => {
          setShowDeletePermanentlyModal(false)
        }}
        onClickClose={() => setShowDeletePermanentlyModal(false)}
      />

      {props.manageDocument && (
        <>
          <Row className="mb-4 position-relative manage-document-knowledge">
            <Col lg={12} md={12} className="knowledge-modules mb-4 mb-md-0">
              <div className="knowledge-box p-0 build-knowbox text-left d-flex flex-column">
                {!allKnowledgeLoading && knowledgeHtml}
              </div>
            </Col>
          </Row>
        </>
      )}

      {!props.manageDocument && (
        <>
          <div>
            <div className="tw-flex">
              <KGroupsTree
                syncsState={true}
                actions={{ add: true, edit: true, delete: true }}
                archivedRoute={KNOWLEDGE_ARCHIVED}
                showsManageGroups={true}
                slotProps={{ root: { className: 'tw-w-2/12' } }}
                onSelectGroup={group => {
                  setSelectedGroup(group)
                }}
              />
              <div className="tw-w-10/12">
                <Box
                  className="tw-px-4 tw-py-2"
                  sx={{ '& nav': { display: 'inline-flex' } }}
                >
                  <Tabs
                    activeKey={activeTab}
                    onSelect={(e: string | null) => {
                      if (!e) return
                      setActiveTab(e)
                      const params = new URLSearchParams(
                        history.location.search,
                      )
                      params.set('activeTab', e)
                      history.replace({
                        pathname: history.location.pathname,
                        search: params.toString(),
                      })
                    }}
                  >
                    <Tab eventKey="viewDocument" title="Documents">
                      {activeTab === 'viewDocument' && (
                        <UploadedDocuments
                          isArchived={true}
                          queryString={`?group=${selectedGroup?._id}`}
                          selectedGroupId={selectedGroup?._id}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="viewKnowledge" title={t('Flash Cards')}>
                      {activeTab === 'viewKnowledge' && knowledgeHtml}
                    </Tab>
                  </Tabs>
                </Box>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ArchiveKnowledgeDatatableView
